export default __webpack_public_path__ + "7f637dabf906b24ed98928a7a74d2fb2.png";